export const i18nConfig = {
  locales: ["en", "de"],
  defaultLocale: "de",
} as const;

export type Locale = (typeof i18nConfig)["locales"][number];
